import { Component, EventEmitter } from '@angular/core'
import {
  AdvancedOptionsBase,
  AdvancedOptionsParams,
} from '@helios/filter-modal'
import { Daterange } from '@northfork/ng-basics'
import { DistributionAdvancedOptions } from '../../models/distribution.model'

@Component({
  selector: 'hs-distributions-advanced-options',
  templateUrl: './distributions-advanced-options.component.html',
})
export class DistributionsAdvancedOptionsComponent extends AdvancedOptionsBase<
  unknown,
  DistributionAdvancedOptions
> {
  onChange = new EventEmitter<
    AdvancedOptionsParams<unknown, DistributionAdvancedOptions>
  >()

  set advancedOptionsParams(
    value: AdvancedOptionsParams<unknown, DistributionAdvancedOptions>,
  ) {
    this.dateRange = value.dateRange
  }

  dateRange?: Daterange

  onModelChange(range: Daterange) {
    this.onChange.emit({
      dateRange: range,
      context: {},
    })
  }

  onApply() {
    return
  }
}
